import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Card,
  Chip,
  Grid2,
  Tab,
  Tabs,
  TextField,
  Typography,
  MenuItem,
  IconButton,
  Menu,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormControl,
  InputLabel,
  Select,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  Paper,
  TableBody,
  Alert,
  CircularProgress,
  FormGroup,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import { styled } from "@mui/material/styles";
import { RiEditCircleFill, RiMoreFill } from "react-icons/ri";
import { FiSearch } from "react-icons/fi";
import { IoMdAdd } from "react-icons/io";
import { VscEdit } from "react-icons/vsc";
import InputAdornment from "@mui/material/InputAdornment";
import Layout from "../../components/Layout/Layout";
import { useNavigate } from "react-router-dom";
import { HiOutlineArrowSmLeft, HiOutlineArrowSmRight } from "react-icons/hi";
import { saveAs } from "file-saver";
import Papa from "papaparse";
import { ActivateSignUpCode, ArchiveSignUpCode, PauseSignUpCode, createSignUpCode, getSignUpCodes, getSignUpUsers, updateSignUpCode } from "../../API/SignUpCodesAPI/SignUpCodesAPI";
import dayjs from "dayjs";
import { Form, InputGroup } from "react-bootstrap";
import { DataGrid } from "@mui/x-data-grid";
import { COL_BLACK } from "../../constants/colors";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

// Mock data
const activeCodes = [
    {
      code: "FREE7",
      title: "Thanks For Listening! Enjoy A Commission Free Week!",
      status: "Active",
      type: "Free Commission",
      duration: 7,
      timesUsed: 100,
      avgRev: 9999,
      totalRev: 9999,
      netReturn: 9999,
      roi: 50,
    },
    {
        code: "FREE0",
        title: "Thanks For Listening! Enjoy A Free 10 Cash for Week!",
        status: "Active",
        type: "Free Commission",
        duration: 7,
        timesUsed: 100,
        avgRev: 9999,
        totalRev: 9999,
        netReturn: 9999,
        roi: 50,
      },
      {
        code: "FREE14",
        title: "Thanks For Listening! Enjoy A Free 2 Cash Week!",
        status: "Active",
        type: "Free Commission",
        duration: 7,
        timesUsed: 100,
        avgRev: 9999,
        totalRev: 9999,
        netReturn: 9999,
        roi: 50,
      },
  ];
  
  const archivedCodes = [
    {
      code: "SUMMER50",
      title: "Summer Sale 50% Discount",
      status: "Archived",
      type: "Discount",
      duration: 30,
      timesUsed: 250,
      avgRev: 5000,
      totalRev: 125000,
      netReturn: 115000,
      roi: 45,
    },
  ];

  const StyledTableCell = styled(TableCell)(() => ({
    fontWeight: 600,
    color: "#2d2d2d",
    fontSize: "13px",
    borderBottom: "1px solid #e0e0e0",
  }));
  
  const StyledTableRow = styled(TableRow)(() => ({
    "&:nth-of-type(even)": {
      backgroundColor: "#f9f9f9",
    },
  }));
const StyledCard = styled(Card)(({ theme }) => ({
  backgroundColor: "#ffffff",
  color:"#424242BF",
  borderRadius: 16,
  padding: theme.spacing(3),
  marginTop: theme.spacing(2),
  boxShadow: "0px 2px 2px 2px rgba(0,0,0,0.3)",
  width:"98%",
  marginLeft:'0.5%'
}));

const LabelText = styled(Typography)(() => ({
  fontSize: "12px",
  fontWeight: 700,
  lineHeight: "14.88px",
  textAlign: "left",
  color: "#ffffffff",
}));

const SmallLabel = styled(Typography)(() => ({
  fontSize: "10px",
  fontWeight: 700,
  textAlign: "left",
  color: "#424242BF",
}));

const getStatusStyle = (status) => {
  switch (status?.toUpperCase()) {
    case "ACTIVE":
      return { backgroundColor: "#4CAF50", color: "#fff" }; // Green
    case "PAUSED":
      return { backgroundColor: "#FF9800", color: "#fff" }; // Orange
    case "EXPIRED":
      return { backgroundColor: "#F44336", color: "#fff" }; // Red
    case "ARCHIVED":
      return { backgroundColor: "#9E9E9E", color: "#fff" }; // Gray
    default:
      return { backgroundColor: "#BDBDBD", color: "#fff" }; // Light gray fallback
  }
};


const formatToUSDate = (dateString) => {
    if (!dateString) return "—"; // handle null or undefined
    const date = new Date(dateString);
    if (isNaN(date)) return "Invalid Date";
    
    const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-indexed
    const day = String(date.getDate()).padStart(2, "0");
    const year = date.getFullYear();
  
    return `${month}/${day}/${year}`;
  };
  
  // Converts any ISO or JS Date to `yyyy-MM-dd`
const formatForDateInput = (dateString) => {
  if (!dateString) return "";
  const date = new Date(dateString);
  // Adjust to local timezone if needed
  const offsetDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
  return offsetDate.toISOString().split("T")[0];
};

  const recordCountSelecter = [10, 15, 20, 25, 30];

export default function SignUpCodes() {
  const navigator = useNavigate();
  const [tabValue, setTabValue] = useState(0);
  const [filterType, setFilterType] = useState('All');
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedCard, setSelectedCard] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [editCampaign, setEditCampaign] = useState(null);
  const [searchQuery,setSearchQuery] = useState('');
  const [refresh,setRefresh]=useState(true);
  const [loading,setIsLoading]=useState(false);
  const [SignUpCodes,setSignUpCodes] = useState([]);
  const startOfYear = dayjs().startOf('year');
  const [startDate, setStartDate] = useState(startOfYear);
  const [endDate, setEndDate] = useState(dayjs(new Date()));
  const [formData, setFormData] = useState({
                code: "",
              message: "",
              expireAt: "",
              referralType: "",
              rabbetCommissionDuration : null,
              rabbetKarats: null,
              rabbetCoins: null,
  });
  const [expandedCard, setExpandedCard] = useState(null);
  const [tableLoading,setTableLoading] = useState(false); 
  const [tableUsers,setTableUsers] = useState([]);
  const [tableSearchQuery, setTableSearchQuery] = useState("");
  const [searchBtnClicked,setSearchBtnClicked]=useState(false);
  const [pageCount, setPageCount] = useState(1);
  const [recordCount, setRecordCount] = useState(recordCountSelecter[0]);
  const navigate = useNavigate();
//   const [tabValue, setTabValue] = useState(0);
//   const [anchorEl, setAnchorEl] = useState(null);
  const [selectedRow, setSelectedRow] = useState(null);
  const statuses = tabValue === 0 
  ? ["ACTIVE", "PAUSED",] 
  : ["ARCHIVED","EXPIRED"];

  useEffect(() => {
    const token = sessionStorage.getItem('token');
    if (token) {
      console.log('Token retrieved:', token,searchQuery,startDate,endDate,filterType);
      setIsLoading(true);
    getSignUpCodes(token,searchQuery,startDate,endDate,filterType ==='All'?null:filterType,statuses)
    .then((res)=>{
        console.log("SIGNUP CODES:",res?.data?.data);
        setSignUpCodes(res?.data?.data)
        setIsLoading(false);
    }).catch((err)=>{
        console.log(err)
        setIsLoading(false);
    })
    } else {
      console.log("Token Not Found");
      // Redirect to login page or display a message
    }
  }, [tabValue,searchQuery,refresh,filterType,startDate,endDate]);

  useEffect(() => {
    const token = sessionStorage.getItem('token');
    if (token) {
      if(expandedCard){
        console.log('Token retrieved:', token,expandedCard);
        setTableLoading(true);
        getSignUpUsers(token,expandedCard,tableSearchQuery)
      .then((res)=>{
          console.log("SIGNUP USERS:",res?.data?.data);
          setTableUsers(res?.data?.data)
          setTableLoading(false);
      }).catch((err)=>{
          console.log(err)
          setTableLoading(false);
      })
      } else {
        console.log("Token Not Found");
        // Redirect to login page or display a message
      }
      }
      
  }, [expandedCard,pageCount,recordCount,searchBtnClicked]);

  const handleJsonExport = () => {
    try {
      if(tableUsers && Object.keys(tableUsers).length > 0){
          const json = JSON.stringify(tableUsers ?? {});
  
          const blob = new Blob([json], { type: "application/json;charset=utf-8;" });

          saveAs(blob, `rabbet-users-details.json`);
      }
      else{
        alert("No users data available to export.");
      }        
    } catch (err) {
      console.error("Error converting JSON to file:", err);
    }
  };

  const CustomCellComponent = ({ value }) => {
    // console.log(value)
    return (
      <div style={{ display: "flex", justifyContent: "space-around" }}>
        <div
          onClick={() => {
            navigator("/Users/UserInLineEditView/" + value);
          }}
        >
          <RiEditCircleFill
            style={{ color: "#EEB50C", fontSize: "1.4vw", cursor: "pointer" }}
          />
        </div>
      
        {/* <div>
          <IoMdAddCircle
            style={{ color: "#70AA2C", fontSize: "1.4vw", cursor: "pointer" }}
          />
        </div>
        <div>
          <FaUser
            style={{ color: "#1814F3", fontSize: "1.4vw", cursor: "pointer" }}
          />
        </div>
        <div>
          <TiDelete
            style={{ color: "#EF4B4B", fontSize: "1.6vw", cursor: "pointer" }}
          />
        </div> */}
      </div>
    );
  };

  const getColumns = () => {
    const filteredEntries = Object.entries(
      Object.assign({}, ...tableUsers)
    ).filter(
      ([key, value]) =>
        typeof value !== "function" &&
        typeof value !== "object" &&
        typeof value !== "symbol" &&
        typeof value !== "undefined"
    );
    const filteredObject = Object.fromEntries(filteredEntries);
    const dataKeys = Object.keys(filteredObject);
    return dataKeys.map((item, index) => {
      return index === 0
        ? {
            field: item,
            headerName: item,
            align: "center",
            headerAlign: "center",
            sortable: false,
            editable: false,
            renderCell: (params) => {
              return <CustomCellComponent value={params.value} />;
            },
            width: 150,
          }
        : {
            field: item,
            headerName: item,
            align: "center",
            headerAlign: "center",
            sortable: false,
            editable: true,
          };
    });
  };

  const columns: GridColDef[] = [...getColumns()];

  const rows = tableUsers.map((item, index) => {
    const filteredEntries = Object.entries(item ?? {}).filter(
      ([key, value]) =>
        typeof value !== "function" &&
        typeof value !== "object" &&
        typeof value !== "symbol" &&
        typeof value !== "undefined"
    );
    const filteredObject = Object.fromEntries(filteredEntries);
    return { ...filteredObject, id: index };   
  });





  // Open modal for new campaign
const handleOpenModal = () => {
    setIsEditing(false);
    setFormData({
        code: "",
        message: "",
        expireAt: "",
        referralType: null,
        rabbetCommissionDuration : null,
        rabbetKarats: null,
        rabbetCoins: null,
    });
    setIsModalOpen(true);
  };

  // Open modal for edit
// const handleEdit = (campaign) => {
//     setIsEditing(true);
//     setEditCampaign(campaign);
//     setFormData({
//       title: campaign.title,
//       userMessage: campaign.userMessage || campaign.title,
//       durationDays: campaign.duration || "",
//       expiryDate: campaign.expiryDate || "",
//       filterType: campaign.type || "",
//     });
//     setIsModalOpen(true);
//     handleMenuClose();
//   };
  
const handleSave = () => {
    // Clean up form data (set irrelevant values to null)
    const dataToSend = {
      ...formData,
      karats:
        formData.filterType.includes("Karats") || formData.filterType.includes("Cash & Karats")
          ? formData.karats
          : null,
      cash:
        formData.filterType.includes("Cash") || formData.filterType.includes("Cash & Karats")
          ? formData.cash
          : null,
      commission: formData.filterType === "Commission Free" ? formData.commission : null,
    };
    handleSaveCampaign(dataToSend);
  };

  // Save or Update Campaign
const handleSaveCampaign = () => {
  const { referralType } = formData;

  // Validation based on referralType
  if (!referralType || referralType.trim() === "") {
    alert("Please select a campaign type before saving.");
    return;
  }

  // Field checks depending on referralType
  switch (referralType) {
    case "Commission Free":
      if (!formData.rabbetCommissionDuration) {
        alert("Please enter Commission Duration (Days).");
        return;
      }
      break;

    case "Award Cash":
      if (!formData.rabbetKarats) {
        alert("Please enter the Cash ($) amount.");
        return;
      }
      break;

    case "Award Karats":
      if (!formData.rabbetCoins) {
        alert("Please enter the Karats value.");
        return;
      }
      break;

    case "Award Cash & Karats":
      if (!formData.rabbetKarats || !formData.rabbetCoins) {
        alert("Please enter both Cash ($) and Karats values.");
        return;
      }
      break;

    case "All Benefits":
      if (!formData.rabbetCommissionDuration || !formData.rabbetKarats || !formData.rabbetCoins) {
        alert("Please fill all fields: Commission Duration, Cash ($), and Karats.");
        return;
      }
      break;

    default:
      alert("Invalid campaign type selected.");
      return;
  }

  // Common validation
  if (!formData.code || formData.code.trim() === "") {
    alert("Please enter the campaign code.");
    return;
  }

  if (!formData.expireAt) {
    alert("Please select an expiry date.");
    return;
  }

    if (isEditing) {
      console.log("Edit Campaign Details",editCampaign)
      const token = sessionStorage.getItem('token');
      const payload={
        ...formData,
        expireAt: new Date(formData.expireAt).toISOString(),
        code: formData.code.toUpperCase() ?? ''
      }
      
      updateSignUpCode(token,editCampaign?._id,payload)
      .then((res)=>{
        console.log(res?.data);
        setIsModalOpen(false);
        alert('Sign Up code Updated Successfully!')
        setRefresh(!refresh);
      })
      .catch((err)=>{
        console.log(err);
        alert('Please Try Again! Sign Up Not Updated')
      })
      console.log("Updating Campaign:", payload.code);
      // Replace the object in your activeCodes/archivedCodes state
    } else {
      console.log("Creating new campaign:", formData);
      // Push into activeCodes
      const token = sessionStorage.getItem('token');
      if(token){
        createSignUpCode(token,formData)
        .then((res)=>{
          console.log(res?.data);
          setIsModalOpen(false);
          setRefresh(!refresh);
          alert('SignUp Code Created Successfully')
        })
        .catch((err)=>{
          console.log(err);
        })
      }
      }
   
    
  };

  // Decide which list to show
  const currentData = tabValue === 0 ? activeCodes : archivedCodes;
  const filteredData = filterType
    ? currentData.filter((item) => item.type === filterType)
    : currentData;

    const handleMenuOpen = (event,item, index) => {
        setAnchorEl(event.currentTarget);
        console.log("Selected Card details",item,index)
        setSelectedCard(item);
      };
      
      const handleMenuClose = () => {
        setAnchorEl(null);
        setSelectedCard(null);
      };
      
      const handleSetArchived = () => {
        console.log("Set card to archived:", currentData[selectedCard]);
        // You can update state here to move the card from activeCodes to archivedCodes
        handleMenuClose();
      };


      // const handleMenuOpen = (event, row) => {
      //   setAnchorEl(event.currentTarget);
      //   setSelectedRow(row);
      // };
    
      // const handleMenuClose = () => {
      //   setAnchorEl(null);
      //   setSelectedRow(null);
      // };
    
      const handleEdit = () => {
        console.log("Editing:", selectedCard);
        setIsEditing(true);
            setEditCampaign(selectedCard);
            setFormData({
              code: selectedCard.code,
              message: selectedCard.message || selectedCard.title,
              expireAt: selectedCard.expireAt || "",
              referralType: selectedCard.referralType,
              rabbetCommissionDuration : selectedCard.rabbetCommissionDuration,
              rabbetKarats: selectedCard.rabbetKarats,
              rabbetCoins: selectedCard.rabbetCoins,
            });
            setIsModalOpen(true);
            handleMenuClose();
      };
    
      const handlePause =() =>{
        console.log("Move to Paused:", selectedCard);
        const token = sessionStorage.getItem('token');
        PauseSignUpCode(token,selectedCard?._id)
        .then((res)=>{
          console.log(res?.data);
          setSignUpCodes([]);
          setRefresh(!refresh);
        })
        .then((err)=>{
          console.log(err);
          alert('Paused Campaign Successfully');
        })
        handleMenuClose();
      };

      const handleActive =() =>{
        console.log("Move to Active:", selectedCard);
        const token = sessionStorage.getItem('token');
        ActivateSignUpCode(token,selectedCard?._id)
        .then((res)=>{
          console.log(res?.data);
          setSignUpCodes([]);
          setRefresh(!refresh);
        })
        .then((err)=>{
          console.log(err);
          alert('Paused Campaign Successfully');
        })
        handleMenuClose();
      };

      const handleArchive = () => {
        console.log("Move to Archived:", selectedCard);
        const token = sessionStorage.getItem('token');
        ArchiveSignUpCode(token,selectedCard?._id)
        .then((res)=>{
          console.log(res?.data);
          setSignUpCodes([]);
          setRefresh(!refresh);
        })
        .then((err)=>{
          console.log(err);
          alert('Archived PromoCode Successfully');
        })
        handleMenuClose();
      };
    
      // const handleViewDetails = () => {
      //   navigate(`/campaign/${selectedRow.code}`, { state: selectedRow });
      //   handleMenuClose();
      // };

  return (
    <Layout>
    <Box sx={{minHeight: "100vh", p: 2 }}>
      {/* Header */}
      <Typography variant="h5" sx={{ fontWeight: 600, mb: 1 }}>
        Sign Up Codes
      </Typography>
      <LabelText style={{color: "#000000"}}>
        Control and analytics over custom codes users enter during onboarding and their associated awards
      </LabelText>

    {/* Search + Filter + Create Button */}
        <Box
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        mb={3}
        mt={3}
        >
   <Box display="flex" alignItems="center" gap={2}>
  {/* Search Input */}
  <TextField
    variant="outlined"
    placeholder="Search codes..."
    size="small"
    value={searchQuery}
    onChange={(e) => setSearchQuery(e.target.value)}
    InputProps={{
      startAdornment: (
        <InputAdornment position="start">
          <FiSearch style={{ color: "#000000", fontSize: 20 }} />
        </InputAdornment>
      ),
    }}
    sx={{
      width: 280,
      "& .MuiInputBase-root": {
        height: 40,
      },
      input: { color: "#000000", fontSize: 13 },
    }}
  />

  {/* Filter Dropdown */}
  <TextField
    select
    variant="outlined"
    size="small"
    value={filterType}
    onChange={(e) => setFilterType(e.target.value)}
    sx={{
      width: 200,
      "& .MuiInputBase-root": {
        height: 40,
      },
      "& .MuiSelect-select": { color: "#000000", fontSize: 13 },
    }}
  >
    <MenuItem value="All">All Codes</MenuItem>
    <MenuItem value="Commission Free">Commission Free</MenuItem>
    <MenuItem value="Award Karats">Award Karats</MenuItem>
    <MenuItem value="Award Cash">Award Cash</MenuItem>
    <MenuItem value="Award Cash & Karats">Award Cash & Karats</MenuItem>
    <MenuItem value="All Benefits">All Benefits</MenuItem>
  </TextField>

  {/* Start Date */}
  <LocalizationProvider dateAdapter={AdapterDayjs}>
    <DatePicker
      label="Start Date"
      value={startDate}
      onChange={(newValue) => {
        setPageCount(1);
        setStartDate(newValue);
        setTableLoading(true);
      }}
      minDate={dayjs("2024-04-01")}
      maxDate={dayjs(new Date())}
      disabled={loading}
      slotProps={{
        textField: {
          size: "small",
          sx: {
            "& .MuiInputBase-root": { height: 40 },
            width: 180,
          },
        },
      }}
    />
  </LocalizationProvider>

  {/* End Date */}
  <LocalizationProvider dateAdapter={AdapterDayjs}>
    <DatePicker
      label="End Date"
      value={endDate}
      onChange={(newValue) => {
        setPageCount(1);
        setEndDate(newValue);
        setTableLoading(true);
      }}
      minDate={dayjs("2024-04-01")}
      maxDate={dayjs(new Date())}
      disabled={loading}
      slotProps={{
        textField: {
          size: "small",
          sx: {
            "& .MuiInputBase-root": { height: 40 },
            width: 180,
          },
        },
      }}
    />
  </LocalizationProvider>
</Box>


        {/* Create Button */}
        <Button
            variant="contained"
            sx={{
            backgroundColor: "#1976d2",
            textTransform: "none",
            fontWeight: 600,
            borderRadius: 1.5,
            height: 40,
            px: 2.5,
            }}
            onClick={handleOpenModal}
        >
            Create New Code
        </Button>
        </Box>


      {/* Tabs */}
      <Tabs
        value={tabValue}
        onChange={(e, newVal) => setTabValue(newVal)}
        textColor="inherit"
        TabIndicatorProps={{ style: { background: "red" } }}
        sx={{
          "& .MuiTab-root": { color: "#000000", fontSize: 13, textTransform: "none" },
          "& .Mui-selected": { color: "#ff4040" },
        }}
      >
        <Tab label="Active Codes" value={0} />
        <Tab label="Archived" value={1} />
      </Tabs>

      <LabelText sx={{ mt: 1 }}>
        Control and analytics over custom codes users enter during onboarding and their associated awards
      </LabelText>

   {/* Data Display */}
  {/* Loading Spinner */}
{loading ? (
  <Box
    display="flex"
    justifyContent="center"
    alignItems="center"
    sx={{ height: "60vh" }}
  >
    <CircularProgress sx={{ color: "#1976d2" }} />
  </Box>
) : SignUpCodes.length === 0 ? (
  <Typography
    variant="body1"
    sx={{
      color: "#424242BF",
      textAlign: "center",
      mt: 5,
      fontWeight: 600,
    }}
  >
    {tabValue === 0 ? "No Active Codes Found" : "No Archived Codes Found"}
  </Typography>
) : (
  <Box
    sx={{
      maxHeight: "70vh",
      overflowY: "auto",
      pr: 1,
      "&::-webkit-scrollbar": { width: "2px" },
      "&::-webkit-scrollbar-thumb": {
        backgroundColor: "#cccccc",
        borderRadius: "2px",
      },
      "&::-webkit-scrollbar-thumb:hover": {
        backgroundColor: "#aaaaaa",
      },
      margin: "0px 2px",
    }}
  >
    {SignUpCodes.map((item, index) => (
      <StyledCard key={index} 
      sx={{
        transition: "all 0.3s ease",
        height: expandedCard === item?._id ? "95vh" : "auto",
        overflow: "hidden",
        marginBottom: 2
      }}
      >
        <Typography variant="h6" sx={{ mb: 1, color: "#424242BF" }}>
          Campaign Title
        </Typography>

        {/* Header with Chips + Menu */}
        <Box display="flex" alignItems="center" justifyContent="space-between">
          <Box display="flex" alignItems="center" gap={1}>
            <Chip label={item.code} 
             sx={{
              backgroundColor: "#1976d2", // Blue
              color: "#fff",
              fontWeight: 700,
              fontSize: "0.95rem",
              letterSpacing: 1,
              px: 1.5,
              // borderRadius: 1,
              boxShadow: "0 2px 6px rgba(25, 118, 210, 0.3)",
            }}
          
            />
            <Chip  label={item?.status || "Unknown"}
                  sx={{
                    ...getStatusStyle(item?.status),
                    fontWeight: 600,
                    letterSpacing: 0.5,
                  }}
                  />
            <Chip
              label={
                ["Award Cash", "Award Karats", "Award Cash & Karats"].includes(item.referralType)
                  ? `${item.referralType} - ${
                      item.referralType === "Award Cash"
                        ? item?.rabbetKarats ?? 0
                        : item.referralType === "Award Karats"
                        ? item?.rabbetCoins ?? 0
                        : `${item?.rabbetCoins ?? 0} & ${item?.rabbetKarats ?? 0}`
                    }`
                  : item.referralType
              }
              sx={{
                border: "1px solid #1976d2",
                color: "#1976d2",
                background: "transparent",
              }}
            />
          </Box>

          {/* Menu Button */}
          <Box>
            <IconButton
              size="small"
              onClick={(e) => handleMenuOpen(e, item, index)}
              sx={{ color: "#424242BF" }}
            >
              <RiMoreFill size={24} />
            </IconButton>
          </Box>
        </Box>

        {/* User Message */}
        <Box sx={{ mt: 3 }}>
          <SmallLabel>User Message:</SmallLabel>
          <Typography variant="body1" sx={{ fontWeight: 600, color: "#424242BF" }}>
            {item.message}
          </Typography>
        </Box>

        {/* Stats Grid */}
        <Grid2 container spacing={2} sx={{ mt: 3 }}>
         {item.rabbetKarats && (
          <Grid2 item xs={6} sm={4} md={2}>
            <InfoBox label="Cash" value={item.rabbetKarats} />
          </Grid2>
         )
         } 
         {
          item.rabbetCoins && (
            <Grid2 item xs={6} sm={4} md={2}>
            <InfoBox label="Coins" value={item.rabbetCoins} />
          </Grid2>
          )
         }
        {
          item.rabbetCommissionDuration && (
            <Grid2 item xs={6} sm={4} md={2}>
            <InfoBox label="Duration" value={item.rabbetCommissionDuration} />
          </Grid2>
          )
        }
         
          <Grid2 item xs={6} sm={4} md={2}>
            <InfoBox label="Times Used" value={item?.stats?.timesUsed} />
          </Grid2>
          <Grid2 item xs={6} sm={4} md={2}>
            <InfoBox label="Avg. Rev / User" value={`${item?.stats?.avgRevenue}`} />
          </Grid2>
          <Grid2 item xs={6} sm={4} md={2}>
            <InfoBox label="Total Revenue" value={`${item?.stats?.totalRevenue}`} />
          </Grid2>
          <Grid2 item xs={6} sm={4} md={2}>
            <InfoBox label="Net Return" value={`${item?.stats?.netReturn}`} />
          </Grid2>
          <Grid2 item xs={6} sm={4} md={2}>
            <InfoBox label="ROI" value={`${item?.stats?.roi}`} />
          </Grid2>
        </Grid2>

        {/* Footer Row */}
      <Box display="flex" alignItems="center" gap={2} mt={3}>
          <Box style={{display:'flex',flexDirection:'column'}}>
          <LabelText style={{color:COL_BLACK}}>Active Since</LabelText>
              <TextField
            variant="outlined"
            placeholder="Active Since"
            size="small"
            value={formatToUSDate(item?.createdAt)}
            sx={{ backgroundColor: "#111111bf", width: 150, input: { color: "#ffffffff" } }}
          />
          </Box>
          <Box style={{display:'flex',flexDirection:'column'}}>
          <LabelText style={{color:COL_BLACK}}>
          Last Used
          </LabelText>
          <TextField
            variant="outlined"
            placeholder="Last Used"
            value={formatToUSDate(item?.createdAt)}
            size="small"
            sx={{ backgroundColor: "#111111bf", width: 150, input: { color: "#fff" } }}
          />
          </Box>
          <Box style={{display:'flex',flexDirection:'column'}}>
          <LabelText style={{color:COL_BLACK}}>Expires On </LabelText>
          <TextField
            variant="outlined"
            placeholder="Expires On"
            size="small"
            value={formatToUSDate(item?.expireAt)}
            sx={{ backgroundColor: "#111111bf", width: 150, input: { color: "#fff" } }}
          />
        </Box>
     
 
  {/* Right-aligned buttons */}
  <Box ml="auto" display="flex" alignItems="center" gap={1}>
    {expandedCard === item?._id? (
      <>
        <Button
          variant="outlined"
          onClick={() => setExpandedCard(null)}
          sx={{
            textTransform: "none",
            fontWeight: 600,
            borderRadius: 1.5,
            color: "#1976d2",
            borderColor: "#1976d2",
          }}
        >
          Hide
        </Button>
        <Button
          variant="contained"
          disabled
          sx={{
            textTransform: "none",
            fontWeight: 600,
            borderRadius: 1.5,
            backgroundColor: "#1976d2",
          }}
        >
          View Users
        </Button>
      </>
    ) : (
      <Button
        variant="contained"
        onClick={() => setExpandedCard(item?._id)}
        sx={{
          textTransform: "none",
          fontWeight: 600,
          borderRadius: 1.5,
          backgroundColor: "#1976d2",
        }}
      >
        View Users
      </Button>
    )}
  </Box>
      
  </Box>
        {/* Conditionally render user table below */}
  {expandedCard === item?._id && (
    <Box sx={{ mt: 2, backgroundColor: "#5a5858", borderRadius: 2, p: 1 }}>
      {/* Include your full tableUsers block here */}
      <div style={{display:'flex',flexDirection:'row',justifyContent:'space-between'}}>
      <div style={{width:'70%'}}>
        <InputGroup className="mb-3 px-2">
          <Form.Control
            aria-label="Text input with dropdown button"
            placeholder="Enter Name or phone number to search"
            onChange={(event) => setTableSearchQuery(event.target.value)}
            value={tableSearchQuery}
            onKeyDown={(event) => {
              if (event.key === "Enter") {
                setSearchBtnClicked(!searchBtnClicked);
                event.preventDefault();
              }
            }}
          />
          <Button
            variant="outline-secondary"
            id="button-addon2"
            style={{
              backgroundColor: "#0079FF",
              color: "white",
              padding: "0px 5px",
            }}
            disabled={loading}
            onClick={() => setSearchBtnClicked(!searchBtnClicked)}
          >
            Search
          </Button>
        </InputGroup>
      </div>

      <Button id="button-addon2"className="mb-3 px-5"  style={{backgroundColor:"#0079FF",color:"white",border:"none",marginLeft:10, padding: "0px 5px",}} onClick={()=>{handleJsonExport()}}>
                          Export users data json
      </Button>  
      </div>
     

      <div style={{ margin: "0vw 0.5vw" }}>
        <Paper sx={{ height: "50vh", width: "100%", overflow: "hidden" }}>
          <DataGrid
            rows={rows}
            columns={columns}
            paginationMode="client"
            pageSizeOptions={[5, 10, 15]}
            pagination
            sx={{ border: 0 }}
            loading={tableLoading}
            disableRowSelectionOnClick

          />
          {/* Pagination Controls */}
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "center",
              marginTop: "1%",
              paddingRight: "2%",
            }}
          >
            <div style={{ display: "flex", alignItems: "center" }}>
              <p style={{ margin: "0 0.5vw", color: "white" }}>Rows per page</p>
              <Form.Select
                size="sm"
                onChange={(event) => setRecordCount(event.target.value)}
                disabled={loading}
              >
                {recordCountSelecter.map((value, index) => (
                  <option key={index + "values"}>{value}</option>
                ))}
              </Form.Select>

              <Button
                onClick={() => setPageCount((page) => page - 1)}
                disabled={pageCount <= 1 || loading}
              >
                <HiOutlineArrowSmLeft />
              </Button>

              <p style={{ margin: "0 0.5vw", color: "white" }}>{pageCount}</p>

              <Button onClick={() => setPageCount((page) => page + 1)} disabled={loading}>
                <HiOutlineArrowSmRight />
              </Button>
            </div>
          </div>
        </Paper>
      </div>
    </Box>
  )}
      </StyledCard>
    ))}
  </Box>
)}


<Dialog
  open={isModalOpen}
  onClose={() => setIsModalOpen(false)}
  maxWidth="sm"
  fullWidth
  PaperProps={{
    sx: { color: "#565656", borderRadius: 3, p: 2 },
  }}
>
  <DialogTitle sx={{ fontWeight: 700 }}>
    {isEditing ? "Edit Campaign" : "Create New Campaign"}
  </DialogTitle>

  <DialogContent>
    <Box display="flex" flexDirection="column" gap={2} mt={1}>
      {/* SignUp Code */}
      <TextField
        label="SignUp Code"
        value={formData.code}
        onChange={(e) => setFormData({ ...formData, code: (e.target.value || "").toUpperCase()})}
        fullWidth
        variant="outlined"
        InputLabelProps={{ style: { color: "#000000" } }}
        inputProps={{ style: { color: "#000000" } }}
        sx={{ backgroundColor: "#ebebeb" }}
      />

      {/* User Message */}
      <TextField
        label="User Message"
        value={formData.message}
        onChange={(e) => setFormData({ ...formData, message: e.target.value })}
        fullWidth
        variant="outlined"
        InputLabelProps={{ style: { color: "#000000" } }}
        inputProps={{ style: { color: "#000000" } }}
        sx={{ backgroundColor: "#ebebeb" }}
      />

      {/* Expiry Date */}
      <TextField
        label="Expiry Date"
        type="date"
        value={formatForDateInput(formData.expireAt)}
        onChange={(e) => setFormData({ ...formData, expireAt: e.target.value })}
        fullWidth
        InputLabelProps={{ style: { color: "#000000" }, shrink: true }}
        inputProps={{ style: { color: "#000000" } }}
        sx={{ backgroundColor: "#ebebeb" }}
      />

      {/* Campaign Type - Checkboxes with Inputs beside */}
      <Box>
  <Typography sx={{ fontWeight: 600, mb: 1 }}>Select Campaign Type</Typography>
  <FormGroup>
    {[
      "Commission Free",
      "Award Cash",
      "Award Karats",
      "Award Cash & Karats",
      "All Benefits",
    ].map((type) => {
      const isSelected = formData.referralType === type;

      return (
        <Box
          key={type}
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          gap={2}
          sx={{
            backgroundColor: "#f6f6f6",
            borderRadius: 1,
            p: 1,
            mb: 1,
          }}
        >
          <FormControlLabel
            control={
              <Checkbox
                checked={isSelected}
                // checked={isSelected}
                // disabled={isDisabled}
                onChange={(e) => {
                  let updated;
                  if (e.target.checked) {
                    updated = type; // Only one selection at a time
                  } else {
                    updated = "";
                  }
                  setFormData({ ...formData, referralType: updated });
                }}
              />
            }
            label={type}
            sx={{ flex: 1 }}
          />

          {/* Conditional Inputs */}
          {isSelected && (
            <>
              {type === "Commission Free" && (
                <TextField
                  label="Commission Duration (Days)"
                  type="number"
                  size="small"
                  value={formData.rabbetCommissionDuration || ""}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      rabbetCommissionDuration: e.target.value,
                    })
                  }
                  sx={{
                    width: 160,
                    backgroundColor: "#ebebeb",
                  }}
                  InputLabelProps={{ style: { color: "#000000" } }}
                  inputProps={{ style: { color: "#000000" } }}
                />
              )}

              {type === "Award Cash" && (
                <TextField
                  label="Cash ($)"
                  type="number"
                  size="small"
                  value={formData.rabbetKarats || ""}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      rabbetKarats: e.target.value,
                    })
                  }
                  sx={{
                    width: 160,
                    backgroundColor: "#ebebeb",
                  }}
                  InputLabelProps={{ style: { color: "#000000" } }}
                  inputProps={{ style: { color: "#000000" } }}
                />
              )}

              {type === "Award Karats" && (
                <TextField
                  label="Karats"
                  type="number"
                  size="small"
                  value={formData.rabbetCoins || ""}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      rabbetCoins: e.target.value,
                    })
                  }
                  sx={{
                    width: 160,
                    backgroundColor: "#ebebeb",
                  }}
                  InputLabelProps={{ style: { color: "#000000" } }}
                  inputProps={{ style: { color: "#000000" } }}
                />
              )}

              {type === "Award Cash & Karats" && (
                <Box display="flex" gap={1}>
                  <TextField
                    label="Cash ($)"
                    type="number"
                    size="small"
                    value={formData.rabbetKarats || ""}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        rabbetKarats: e.target.value,
                      })
                    }
                    sx={{
                      width: 120,
                      backgroundColor: "#ebebeb",
                    }}
                    InputLabelProps={{ style: { color: "#000000" } }}
                    inputProps={{ style: { color: "#000000" } }}
                  />
                  <TextField
                    label="Karats"
                    type="number"
                    size="small"
                    value={formData.rabbetCoins || ""}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        rabbetCoins: e.target.value,
                      })
                    }
                    sx={{
                      width: 120,
                      backgroundColor: "#ebebeb",
                    }}
                    InputLabelProps={{ style: { color: "#000000" } }}
                    inputProps={{ style: { color: "#000000" } }}
                  />
                </Box>
              )}

              {type === "All Benefits" && (
                <Box display="flex" gap={1}>
                  <TextField
                    label="Commission Duration (Days)"
                    type="number"
                    size="small"
                    value={formData.rabbetCommissionDuration || ""}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        rabbetCommissionDuration: e.target.value,
                      })
                    }
                    sx={{
                      width: 120,
                      backgroundColor: "#ebebeb",
                    }}
                    InputLabelProps={{ style: { color: "#000000" } }}
                    inputProps={{ style: { color: "#000000" } }}
                  />
                  <TextField
                    label="Cash ($)"
                    type="number"
                    size="small"
                    value={formData.rabbetKarats || ""}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        rabbetKarats: e.target.value,
                      })
                    }
                    sx={{
                      width: 120,
                      backgroundColor: "#ebebeb",
                    }}
                    InputLabelProps={{ style: { color: "#000000" } }}
                    inputProps={{ style: { color: "#000000" } }}
                  />
                  <TextField
                    label="Karats"
                    type="number"
                    size="small"
                    value={formData.rabbetCoins || ""}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        rabbetCoins: e.target.value,
                      })
                    }
                    sx={{
                      width: 120,
                      backgroundColor: "#ebebeb",
                    }}
                    InputLabelProps={{ style: { color: "#000000" } }}
                    inputProps={{ style: { color: "#000000" } }}
                  />
                </Box>
              )}
            </>
          )}
        </Box>
      );
    })}
  </FormGroup>
</Box>

    </Box>
  </DialogContent>

  {/* Actions */}
  <DialogActions sx={{ justifyContent: "space-between" }}>
    <Button
      onClick={() => setIsModalOpen(false)}
      sx={{
        borderRadius: 15,
        color: "#fff",
        textTransform: "none",
        backgroundColor: "#EF4B4B",
        "&:hover": { backgroundColor: "#d63c3c" },
      }}
    >
      Cancel
    </Button>
    <Button
      onClick={handleSaveCampaign}
      variant="contained"
      startIcon={isEditing ? <VscEdit /> : <IoMdAdd />}
      sx={{
        backgroundColor: "#63ce2a",
        textTransform: "none",
        fontWeight: 600,
        borderRadius: 5,
      }}
    >
      {isEditing ? "Update Campaign" : "Create Campaign"}
    </Button>
  </DialogActions>
</Dialog>

    {/* TableView of the Data */}

     {/* <TableContainer
        component={Paper}
        sx={{
          mt: 2,
          borderRadius: 2,
          boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
        }}
      >
        <Table>
          <TableHead>
            <TableRow>
              <StyledTableCell>Title</StyledTableCell>
              <StyledTableCell>User Message</StyledTableCell>
              <StyledTableCell>Type</StyledTableCell>
              <StyledTableCell>Duration</StyledTableCell>
              <StyledTableCell>Times Used</StyledTableCell>
              <StyledTableCell>ROI</StyledTableCell>
              <StyledTableCell align="right">Actions</StyledTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {currentData.length === 0 ? (
              <TableRow>
                <TableCell colSpan={8} align="center">
                  {tabValue === 0
                    ? "No Active Codes Found"
                    : "No Archived Codes Found"}
                </TableCell>
              </TableRow>
            ) : (
              currentData.map((row, i) => (
                <StyledTableRow key={i}>
                  <StyledTableCell>{row.code}</StyledTableCell>
                  <StyledTableCell>{row.title}</StyledTableCell>
                  <StyledTableCell>{row.type}</StyledTableCell>
                  <StyledTableCell>{row.duration} Days</StyledTableCell>
                  <StyledTableCell>{row.timesUsed}</StyledTableCell>
                  <StyledTableCell>{row.roi}%</StyledTableCell>
                  <StyledTableCell align="right">
                    <IconButton
                      size="small"
                      onClick={(e) => handleMenuOpen(e, row)}
                    >
                      <RiMoreFill />
                    </IconButton>
                  </StyledTableCell>
                </StyledTableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer> */}

      {/* More Menu */}
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
        PaperProps={{
          sx: {
            borderRadius: 2,
            backgroundColor: "#1c1c1c",
            color: "#fff",
            minWidth: 160,
          },
        }}
      >
        <MenuItem onClick={handleEdit} sx={{ "&:hover": { bgColor: "#333" } }}>
          Edit Campaign
        </MenuItem>
        <MenuItem onClick={selectedCard?.status === "ACTIVE" ? handlePause : handleActive}>{selectedCard?.status === "ACTIVE" ? "Pause" : "Activate"} Campaign</MenuItem>
        <MenuItem onClick={handleArchive}>Move to Archived</MenuItem>
       
        {/* <MenuItem onClick={handleSetArchived}>Move to Archived</MenuItem>  */}
        {/* <MenuItem onClick={handleViewDetails}>View Details</MenuItem> */}
      </Menu>
    </Box>
    </Layout>
  );
}

const InfoBox = ({ label, value }) => (
  <Box
    sx={{
      backgroundColor: "#111111bf",
      borderRadius: 2,
      p: 2,
      textAlign: "center",
    }}
  >
    <LabelText>{label}</LabelText>
    <Typography variant="h6" sx={{ color: "#EF4B4B", fontWeight: 600 }}>
      {value}
    </Typography>
  </Box>
);